import request from "../../utils/request";
import { createAsyncThunk } from "@reduxjs/toolkit";

const getAllHosts = createAsyncThunk(
    "allHosts/getAllHosts",
    async ({limit, status}, { rejectWithValue }) => {

        let url = `/hosts?status=${status}`
        if (limit){
            url = `/hosts?limit=${limit}&status=${status}`
        }
        try {
            const { data } = await request.get(url, {
                withCredentials: true,
            });

            return data;
        } catch (err) {
            return rejectWithValue(err.response?.data || { error: err.message });
        }
    }
)

const getHostDetails = createAsyncThunk(
    "hostDetails/getHostDetails",
    async (hid, { rejectWithValue }) => {
        try {
            const { data } = await request.get(`/hosts/${hid}`, {
                withCredentials: true,
            });

            return data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
)

const getHostProperties = createAsyncThunk(
    "hostProperties/getHostProperties",
    async (id, { rejectWithValue }) => {
        try {
            const { data } = await request.get(`/properties/host/${id}`, {
                withCredentials: true,
            });

            return data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

const deleteHostAction = createAsyncThunk(
    "deleteHost/deleteHostAction",
    async (hid, { rejectWithValue }) => {
        try {
            const { data } = await request.delete(`/hosts/${hid}`, {
                withCredentials: true,
            });

            return data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

const getHostEarnings = createAsyncThunk(
    "hostEarnings/getHostEarnings",
    async (hid, { rejectWithValue }) => {

        let url = `/orders/graph/${hid}?type=host&duration=30&status=completed`;
        
        try {
            const { data } = await request.get(url, {
                withCredentials: true,
            });

            return data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

const getHostPendingEarnings = createAsyncThunk(
    "hostPendingEarnings/getHostPendingEarnings",
    async (hid, { rejectWithValue }) => {

        let url = `/orders/graph/${hid}?type=host&duration=30&status=pending,picked,requested`;
        
        try {
            const { data } = await request.get(url, {
                withCredentials: true,
            });
            return data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

const saveHostNotes = createAsyncThunk(
  "hostNotes/saveHostNotes",
  async ({ hid, notes }, { rejectWithValue }) => {
    try {
    console.log(`WE IN ${hid}`)
      const { data } = await request.post(
        `/hosts/notes/${hid}`,
        { internalHostNotes: notes },
        { withCredentials: true }
      );
      return data;                               // contains the updated notes
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const updateHostDetails = createAsyncThunk(
  "hostDetails/updateHostDetails",
  async ({ hid, profileCredentials }, { rejectWithValue }) => {
    try {
      const { data } = await request.patch(
        `/hosts/${hid}`,
        profileCredentials,
        { withCredentials: true }
      );
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: "Failed to update host details" });
    }
  }
);

/** PATCH /hosts/entry-instruction-emails/:hid - dedicated route with rate limit and schema */
const updateEntryInstructionEmails = createAsyncThunk(
  "hostDetails/updateEntryInstructionEmails",
  async ({ hid, receiveEntryInstructionsEmails, entryInstructionsAdditionalEmails }, { rejectWithValue }) => {
    try {
      const list = Array.isArray(entryInstructionsAdditionalEmails) ? entryInstructionsAdditionalEmails : [];
      const { data } = await request.patch(
        `/hosts/entry-instruction-emails/${hid}`,
        {
          receiveEntryInstructionsEmails: Boolean(receiveEntryInstructionsEmails),
          entryInstructionsAdditionalEmails: list,
        },
        { withCredentials: true }
      );
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: "Failed to update entry instruction email preferences" });
    }
  }
);

const getHostConciergeOutreachPreview = createAsyncThunk(
  "hostConciergeOutreach/getPreview",
  async (hid, { rejectWithValue }) => {
    try {
      const { data } = await request.get(
        `/admin/hosts/${hid}/analytics/concierge-outreach/preview`,
        { withCredentials: true }
      );
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: "Failed to load concierge outreach preview" });
    }
  }
);

const sendHostConciergeOutreachEmail = createAsyncThunk(
  "hostConciergeOutreach/sendEmail",
  async ({ hid, from, to, subject, bodyText }, { rejectWithValue }) => {
    try {
      const { data } = await request.post(
        `/admin/hosts/${hid}/analytics/concierge-outreach/send`,
        { from, to, subject, bodyText },
        { withCredentials: true }
      );
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: "Failed to send concierge outreach email" });
    }
  }
);

export { getAllHosts, getHostDetails, getHostProperties, deleteHostAction, getHostEarnings, getHostPendingEarnings, saveHostNotes, updateHostDetails, updateEntryInstructionEmails, getHostConciergeOutreachPreview, sendHostConciergeOutreachEmail }
